import { useState } from "react";
import ProjectCard from "./ProjectCard";

export default function FilterableProjects() {

const projects = [
  {
    image: "/Images/empkhet.png",
    title: "EmpKhet – Organic E-Commerce Platform",
    description:
      "A full-stack DTC platform built with Next.js, Node.js, and MongoDB. Features server-side rendering, custom cart logic, and sub-second load times.",
    link: "https://empkhet.com", 
    categories: ["Next.js", "Node.js", "MongoDB", "Tailwind"],
  },
  {
    image: "/Images/SDAPP.png",
    title: "SDAPP – HubSpot Website & Landing Pages",
    description:
      "Designed the full UI in Figma and developed the HubSpot website + landing pages. Implemented API integrations to upload data and automate lead creation in HubSpot CRM.",
    link: "https://244485737.hs-sites-na2.com/home", 
    categories: ["Figma Design", "HubSpot CMS", "API Integration", "CRM"],
  },
  {
    image: "/Images/Scaler.png", 
    title: "Wasif Kasim – Scaler Landing Page",
    description:
      "Built a high-converting HubSpot landing page using a custom theme setup and reusable modules. Created new modules where needed, ensured old pages were unaffected, and implemented on-page SEO + performance optimizations.",
    link: "https://scale.wasifkasim.com/scaler?hs_preview=aVZCScnA-202436755036",
    categories: ["HubSpot CMS", "JavaScript", "SEO"],
  },
  {
    image: "/Images/Prognos-page.png",
    title: "Prognos Health – Figma to HubSpot Pages",
    description:
      "Converted Figma designs into responsive HubSpot pages with pixel-perfect UI, reusable modules, and SEO-ready structure. Ensured performance, accessibility, and cross-device consistency.",
    link: "https://prognoshealth.com/",
    categories: ["Figma Design", "HubSpot CMS", "Responsive UI", "Custom Modules", "SEO"],
  },
  {
    image: "/Images/Eco.png",
    title: "ECO Multistep Calculator",
    description:
      "Complex pricing calculator built entirely in HubSpot using HubL & JavaScript logic for dynamic quotes.",
    link: "https://info.ecosystems.io/education-portal-test-page?hs_preview=RUfpLics-110012639350",
    categories: ["HubSpot CMS", "JavaScript"],
  },
  {
    image: "/Images/Rj-Lee.png",
    title: "RJ Lee Group (Enterprise Migration)",
    description:
      "Corporate HubSpot CMS migration with custom modules, animation libraries, and modular page architecture.",
    link: "https://www.rjleegroup.com/",
    categories: ["HubSpot CMS", "Theme"],
  },
  {
    image: "Images/Smart-Farming-App.png",
    title: "IoT Smart Farming Dashboard",
    description:
      "Real-time IoT monitoring dashboard visualizing sensor data using React, Firebase, and ESP8266.",
    link: "https://smartfarming.co.in/",
    categories: ["React", "IoT", "Firebase"],
  },
  {
    image: "/Images/Quote.png",
    title: "Watchful – SaaS Quote Template",
    description:
      "B2B HubSpot quote template featuring modular pricing tables and modern SaaS design patterns.",
    link: "https://hubtest-242332888.hubspotpagebuilder.net/aRgry4wk2wxSkGc",
    categories: ["HubSpot CMS", "Templates", "Quote"],
  },
  {
    image: "/Images/Gsp-Home.png",
    title: "GlobalSafe Perkasa – UI Concept",
    description:
      "Custom UI/UX concept developed for a fire safety brand, translated into a responsive HubSpot page.",
    link: "https://test-23616195.hubspotpagebuilder.com/gsp-home",
    categories: ["HubSpot CMS", "Theme"],
  },
  {
    image: "/Images/Theme_thumbnail.png",
    title: "Aura",
    description:
      "Custom UI/UX concept developed for a fire safety brand, translated into a responsive page. Includes a dedicated Figma design created for the theme.",
    link: "https://www.figma.com/design/lLMoZGhX6W1if8xyxW5tYd/Aura-Theme?node-id=1-6131&p=f",
    categories: ["Theme", "Figma Design"],
  },

];

// Generate all categories automatically (unique values)
const allCategories = ["All", ...new Set(projects.flatMap(p => p.categories))];

const [activeCategory, setActiveCategory] = useState("All");

const filteredProjects =
  activeCategory === "All"
    ? projects
    : projects.filter(p => p.categories.includes(activeCategory));

return (
  <div className="filter_projects_section">

{/* FILTER BUTTONS */}
<div className="filters" >

{/* MOBILE DROPDOWN */}
<div className="mobile_dropdown" style={{ display: "none" }}>
  <button
    className="dropdown_trigger"
    onClick={() =>
      document
        .querySelector(".dropdown_list")
        .classList.toggle("open")
    }
    style={{
      padding: "10px 14px",
      borderRadius: "6px",
      border: "1px solid #ccc",
      background: "#fff",
      width: "100%",
      color:"#000",
      textAlign: "left",
      position: "relative",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    }}
  >
    <span>{activeCategory}</span><span> ▼</span>
  </button>

  <div
    className="dropdown_list"
    style={{
      display: "none",
      flexDirection: "column",
      gap: "6px",
      background: "#fff",
      border: "1px solid #ddd",
      borderRadius: "6px",
      marginTop: "6px",
      padding: "10px",
      position: "absolute",
      left: "20px",
      right: "20px",
      height: "300px",
      overflow: "scroll",
    }}
  >
    {allCategories.map((cat) => (
      <div
        key={cat}
        onClick={() => {
          setActiveCategory(cat);
          document.querySelector(".dropdown_list").classList.remove("open");
        }}
        style={{
          padding: "8px 12px",
          borderRadius: "6px",
          cursor: "pointer",
          background: activeCategory === cat ? "#000" : "#fff",
          color: activeCategory === cat ? "#fff" : "#000",
        }}
      >
        {cat}
      </div>
    ))}
  </div>
</div>

{/* DESKTOP BUTTONS */}
<div
  className="button_filters"
  style={{
    marginBottom: "20px",
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
  }}
>
  {allCategories.map((cat) => (
    <button
      key={cat}
      onClick={() => setActiveCategory(cat)}
      className={"filter_btn " + (activeCategory === cat ? "active" : "")}
      style={{
        padding: "8px 14px",
        borderRadius: "6px",
        border: "1px solid #ccc",
        background: activeCategory === cat ? "#000" : "#fff",
        color: activeCategory === cat ? "#fff" : "#000",
        cursor: "pointer",
      }}
    >
      {cat}
    </button>
  ))}
</div>
</div>


    {/* PROJECT GRID */}
    <div className="project_card_container">
      {filteredProjects.map((project, index) => (
        <ProjectCard key={index} {...project} />
      ))}
    </div>

  </div>
);
}
